<template>
  <div class="message-options-dropdown" :style="cssPosition" @wheel="$emit('close')">
    <div class="message-options-dropdown__content">
      <div class="message-options-dropdown__action" @click="$emit('reply')">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.91741 3.3915V5.44866C5.91741 5.53198 5.98496 5.59953 6.06828 5.59953C9.30543 5.59953 12.1817 7.66499 13.216 10.7324L14.3179 14L12.77 12.4521C10.9963 10.6784 8.6427 9.60371 6.14078 9.425C6.02008 9.41638 5.91741 9.51197 5.91741 9.63298V11.6634C5.91741 12.0151 5.48918 12.1878 5.24525 11.9345L1.10928 7.63942C0.959519 7.4839 0.96428 7.2364 1.11991 7.08675L5.25588 3.10985C5.50415 2.87114 5.91741 3.04709 5.91741 3.3915Z" stroke="#CCD7E6" stroke-width="2" stroke-linejoin="round"/>
        </svg>
        <div>{{ $t('chat.message.reply') }}</div>
      </div>
      <div class="message-options-dropdown__action message-options-dropdown__chevron" @click="openUsers">
        <div class="message-options-dropdown__line">
          <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.0826 3.3915V5.44866C10.0826 5.53198 10.015 5.59953 9.93172 5.59953C6.69457 5.59953 3.81833 7.66499 2.78396 10.7324L1.68211 14L3.23004 12.4521C5.00367 10.6784 7.3573 9.60371 9.85922 9.425C9.97992 9.41638 10.0826 9.51197 10.0826 9.63298V11.6634C10.0826 12.0151 10.5108 12.1878 10.7548 11.9345L14.8907 7.63942C15.0405 7.4839 15.0357 7.2364 14.8801 7.08675L10.7441 3.10985C10.4959 2.87114 10.0826 3.04709 10.0826 3.3915Z" stroke="#CCD7E6" stroke-width="2" stroke-linejoin="round"/>
          </svg>
          <div>{{ $t('chat.message.forward') }}</div>
        </div>
        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 12L16 8L12 4" stroke="#CCD7E6" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </div>
<!--      <div class="message-options-dropdown__action" @click="$emit('close')">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 7.66667H14.3333M1 7.66667C1 11.3486 3.98477 14.3333 7.66667 14.3333M1 7.66667C1 3.98477 3.98477 1 7.66667 1M14.3333 7.66667C14.3333 11.3486 11.3486 14.3333 7.66667 14.3333M14.3333 7.66667C14.3333 3.98477 11.3486 1 7.66667 1M7.66667 1C9.33419 2.82557 10.2818 5.19469 10.3333 7.66667C10.2818 10.1386 9.33419 12.5078 7.66667 14.3333M7.66667 1C5.99915 2.82557 5.0515 5.19469 5 7.66667C5.0515 10.1386 5.99915 12.5078 7.66667 14.3333" stroke="#CCD7E6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div>Translate</div>
      </div>-->
      <div class="message-options-dropdown__action" @click="$emit('copy')">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.1111 12.1111V7.77778C12.1111 6.18229 10.8177 4.88889 9.22222 4.88889H4.88889M12.1111 12.1111C12.1111 13.7066 10.8177 15 9.22222 15H4.88889C3.2934 15 2 13.7066 2 12.1111V7.77778C2 6.18229 3.2934 4.88889 4.88889 4.88889M12.1111 12.1111C13.7066 12.1111 15 10.8177 15 9.22222V4.88889C15 3.2934 13.7066 2 12.1111 2H7.77778C6.18229 2 4.88889 3.2934 4.88889 4.88889" stroke="#CCD7E6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div>{{ $t('chat.message.copy') }}</div>
      </div>
      <div class="message-options-dropdown__action" @click="$emit('select')">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 4.66667C2 3.19391 3.19391 2 4.66667 2H11.3333C12.8061 2 14 3.19391 14 4.66667V11.3333C14 12.8061 12.8061 14 11.3333 14H4.66667C3.19391 14 2 12.8061 2 11.3333V4.66667Z" stroke="#CCD7E6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M10.6667 6.33331L7.33341 9.66665L5.66675 7.99998" stroke="#CCD7E6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div>{{ $t('chat.message.select') }}</div>
      </div>
      <div class="message-options-dropdown__extra">
        <div class="message-options-dropdown__action" @click="$emit('delete')">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 5H15" stroke="#C34343" stroke-width="2" stroke-linecap="round"/>
            <path d="M3 5V12C3 13.6569 4.34315 15 6 15H10C11.6569 15 13 13.6569 13 12V5" stroke="#C34343" stroke-width="2"/>
            <path d="M5 2H11" stroke="#C34343" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <div>{{ $t('chat.message.delete') }}</div>
        </div>
        <div class="message-options-dropdown__action" @click="$emit('spam')">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="5" r="0.5" fill="#C34343" stroke="#C34343"/>
            <path d="M8 8V10.6667M4.66667 14H11.3333C12.8061 14 14 12.8061 14 11.3333V4.66667C14 3.19391 12.8061 2 11.3333 2H4.66667C3.19391 2 2 3.19391 2 4.66667V11.3333C2 12.8061 3.19391 14 4.66667 14Z" stroke="#C34343" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>

          <div v-if="message.spam">{{ $t('chat.message.unspam') }}</div>
          <div v-else>{{ $t('chat.message.spam') }}</div>
        </div>
      </div>
    </div>

    <MessageForwardDropdown
      v-if="messageForwardDropdown"
      @close="closeUsers"
      @wheel.native.stop
      @select="$emit('forward', $event)"
    />
  </div>
</template>

<script>
import MessageForwardDropdown from '@/components/chat/MessageForwardDropdown.vue'

export default {
  name: 'MessageOptionsDropdown',
  components: { MessageForwardDropdown },
  props: {
    message: Object,
    position: Object,
    isAdmin: Boolean,
  },
  data: () => ({
    messageForwardDropdown: false
  }),
  computed: {
    cssPosition() {
      return {
        top: `${this.position.y}px`,
        left: `${this.position.x}px`,
      }
    }
  },
  methods: {
    openUsers() {
      this.messageForwardDropdown = true
    },
    closeUsers() {
      this.messageForwardDropdown = false
    },
  }
}
</script>

<style lang="scss">
.message-options-dropdown {
  position: fixed;
  z-index: 9;

  background: #FFFFFF;
  box-shadow: 0px 12px 21px 0px #B4BBC630;
  border-radius: 5px;
  padding: 12px 8px;
  width: 200px;

  &__content {
    position: relative;
  }

  &__action {
    display: flex;
    align-items: center;
    padding: 8px 12px;

    font-size: 15px;
    font-weight: 400;
    line-height: 23.63px;
    color: #474747;

    cursor: pointer;

    > * + * {
      margin-left: 8px;
    }

    &:hover {
      background: #F0F3F7;
    }
  }

  &__extra {
    margin-top: 16px;

    .message-options-dropdown__action {
      color: #C34343;
    }
  }

  &__line {
    display: flex;
    align-items: center;

    > * + * {
      margin-left: 8px;
    }
  }

  &__chevron {
    justify-content: space-between;
  }
}
</style>
